<template>
  <div class="panel-body">
    <template>
      <v-card>
      <v-data-table
        v-model="historyModel"
        :headers="headers"
        :items="history"
        item-key="id"
        class="elevation-1"
        :rows-per-page="rowsPerPage"
        :items-per-page-options="rppItems"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="text-xs-center" width="500px">{{ props.item.deviceType }}</td>
          <td class="text-xs-center" width="500px">{{ props.item.osVersion }}</td>
          <td class="text-xs-center" width="500px">{{ props.item.quberVersion }}</td>
          <td class="text-xs-center" width="500px">{{ formatDate(props.item.createdDate) }}</td>
          <td class="text-xs-left" width="500px">{{ props.item.deviceInfo }}</td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
    </v-card>
    </template>
  </div>

</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      required: true
    }
  },
  data: () => ({
    rppItems: [
      5,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    historyModel: [],
    errors: [],
    headers: [
      { text: 'Device Type', align: 'left', sortable: false, value: 'deviceType' },
      { text: 'OS Version', align: 'center', sortable: false, value: 'osVersion' },
      { text: 'Quber Version', align: 'center', 'sortable': false, value: 'quberVersion' },
      { text: 'Login Date', align: 'center', value: 'createdDate' },
      { text: 'Device Information', sortable: false, value: 'deviceInfo' }
    ],
    history: []
  }),
  created () {
    this.loadHistory()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadHistory()
      }
    }
  },
  methods: {

    async loadHistory () {
      if (this.user == null || this.user.userId == null || this.user.userId === '') {
        // console.log('User ID not set, unable to load history')
        this.history = []
        this.$emit('update:title')
        return
      }
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/${this.user.userId}/login-history?limit=25`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.history = [] } else { this.history = getResponse.data }

      this.$emit('update:title')
    },

    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
